import React from 'react';
import PropTypes from 'prop-types';

const PersonalLoans = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 114 114"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity=".2"
      d="M57 114c31.48 0 57-25.52 57-57S88.48 0 57 0 0 25.52 0 57s25.52 57 57 57z"
      fill="#B1E0E2"
    />
    <path
      d="M67.687 94.658a49.555 49.555 0 011.496-8.443 115.078 115.078 0 004.133-14.963 41.29 41.29 0 00-6.484-11.97M34.272 58.032L26.72 46.811a1.176 1.176 0 01.498-1.568L52.583 28.25M59.352 23.73l6.626-4.454a1.247 1.247 0 011.674 0l6.662 9.975"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.313 66.764l-6.306 2.352a1.283 1.283 0 01-1.639-.463l-8.051-21.66c-.214-.535.214-1.176.926-1.425l46.313-17.279a1.211 1.211 0 011.638.463l8.052 21.625c.213.534-.214 1.175-.927 1.46L54.684 63.773"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.962 71.537a24.95 24.95 0 01-1.71-2.779 39.191 39.191 0 01-2.494-6.02c-.428-1.604-1.603-5.309-1.746-5.914a3.563 3.563 0 00-4.275-2.565A3.349 3.349 0 0045.6 58.07c0 2.315 1.425 7.338 1.282 10.687-.259 3.65-.115 7.318.428 10.937.605 2.743 5.771 15.176 5.771 15.176M56.643 53.15a3.573 3.573 0 106.697-2.494 3.277 3.277 0 00-4.346-1.425 3.207 3.207 0 01-4.31-1.39 3.562 3.562 0 016.661-2.494M56.287 41.926l5.486 14.713"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

PersonalLoans.defaultProps = {
  className: '',
};

PersonalLoans.propTypes = {
  className: PropTypes.string,
};

export default PersonalLoans;
